import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Home from './pages/Home/Home';

function App() {
  const [showSlidebar, setShowSlidebar] = useState(false);

  // Forcer le scroll vers le haut au chargement
  useEffect(() => {
    // Attendre que le DOM soit chargé
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const productionSection = document.getElementById('production');
      if (productionSection) {
        const rect = productionSection.getBoundingClientRect();
        setShowSlidebar(rect.top <= window.innerHeight * 0.5);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header showSlidebar={showSlidebar} />
      <main className="main-content">
        <Home />
      </main>
    </div>
  );
}

export default App;

